import { render, staticRenderFns } from "./UserContactDetails.vue?vue&type=template&id=320dcbb6&"
import script from "./UserContactDetails.vue?vue&type=script&lang=js&"
export * from "./UserContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserContactDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports